/**
 * description 租户间稿件共享弹框
 * created by zhang.yingyu
 * created on 2019-05-17
 */
"use strict";
angular.module("tenantShareManuRecordModule", []).controller("tenantShareManuRecordCtrl", ["$scope", "$modalInstance", "modalDialog", "item", "trsHttpService",
    function($scope, $modalInstance, modalDialog, item, trsHttpService) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {};
            $scope.data = {
                items: [
                    // { name: "租户1·赵科林0" },
                ],
                selectedArray: [],
            };
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            getRecord();
        }

        /**
         * [getRecord 获取共享记录]
         * @return {[type]} [description]
         */
        function getRecord() {
            var params = {
                serviceid: 'mlf_PluralisticShare',
                methodname: 'shareRecords',
                dataId: item.id,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data.success == true) {
                    $scope.data.items = data.data;
                }
            });
        }
        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

    }
]);